var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkBottomLine = function SvgCheckmarkBottomLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.354 10.004c.374.03.64.296.646.642.005.356-.27.632-.66.66-.05.003-.1.001-.151.001H.799c-.041 0-.082.002-.123 0-.394-.024-.67-.288-.676-.644-.005-.367.28-.655.69-.658 1.066-.009 2.132-.003 3.197-.004h8.193c.091 0 .183-.004.274.003zM4.533 7.28 2.22 4.967a.749.749 0 1 1 1.06-1.06l1.783 1.782 5.47-5.47a.75.75 0 0 1 1.06 1.061l-6 6a.749.749 0 0 1-1.06 0z"
  })));
};

export default SvgCheckmarkBottomLine;